import { passkeyClient } from '@better-auth/passkey/client';
import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { apiBaseUrl } from './api';

/** Backoffice: passkey obrigatória. Link mágico só para o primeiro acesso (cadastrar a passkey). */
export const authClient = createAuthClient({
  baseURL: `${apiBaseUrl()}/auth`,
  fetchOptions: { credentials: 'include' },
  plugins: [magicLinkClient(), passkeyClient()],
});

/**
 * Reautenticação para ações críticas: pede a passkey de novo, o que renova `reauth_at` na sessão.
 * Devolve false se a pessoa cancelar.
 */
export async function reauthenticate(): Promise<boolean> {
  const r = await authClient.signIn.passkey();
  return !r?.error;
}
